// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"94c88ca7","453":"5368f69f","551":"68f32e4e","611":"38e7a4f4"}[chunkId] + ".chunk.js";
};